import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'searchSalesRep'
})
export class SearchSalesRepPipe implements PipeTransform {

  transform(salesReps: any, searchText: string) {

     if (!searchText) {
      return salesReps; // Return the original array if search text is empty
    }

    searchText = searchText.toLowerCase(); // Convert the search text to lowercase for case-insensitive comparison

    return salesReps.filter((salesReps: any) => salesReps.sales_rep_name.toLowerCase().includes(searchText));
  }

}
